import React from "react";

import {CurrencyAmountValueBox} from "./boxes/currency-amount-value.box";
import {CurrencyAmountErrorMessageBox} from "./boxes/currency-amount-error-message.box";
import {CurrencyAmountInputBox} from "./boxes/currency-amount-input.box";
import {CurrencyAmountCurrencyBox} from "./boxes/currency-amount-currency.box";
import {CurrencyAmountInputValueBox} from "./boxes/currency-amount-input-value.box";

interface ICurrencyValueInputProps {
    value?: string;
    currencySymbol: string;
    cyClass: string;
    disabled?: boolean
    onChange: (value: string) => void;
    errorMessage?: string;
    errorCyClass?: string;
}

export const CurrencyAmountInput: React.FC<ICurrencyValueInputProps> = (props) => {
    return <CurrencyAmountValueBox>
        <CurrencyAmountInputBox>
            <CurrencyAmountCurrencyBox>
                {props.currencySymbol}
            </CurrencyAmountCurrencyBox>
            <CurrencyAmountInputValueBox
                value={props.value}
                disabled={props.disabled}
                className={props.cyClass}
                onChange={(ev) => {props.onChange(ev.target.value)}}
            />
        </CurrencyAmountInputBox>
        <CurrencyAmountErrorMessageBox visible={Boolean(props.errorMessage)} className={props.errorCyClass}>
            {props.errorMessage}
        </CurrencyAmountErrorMessageBox>
    </CurrencyAmountValueBox>
}
